import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useParams } from 'react-router-dom';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { Config } from '@/config';
import {
  errorModalTextRecoil,
  completeModalRecoil,
  inspectionLogAddModalRecoil,
} from '@/atom/ModalAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import { UploadApi } from '@/sdk/UploadApi';
import { FacilityApi } from '@/sdk/FacilityApi';
import ModalType1 from '@/modal/ModalType1';
import AddressModal from './AddressModal';
import FacilitiesSearchModal from './FacilitiesSearchModal';
import {
  FileUploadDto,
  GetFacilitiesDtoRx,
  CreateDeviceDtoTx,
  Calibration,
  CreateInspectionLogDtoTx,
} from '@/sdk/data-contracts';

const InspectionLogAddModal = () => {
  const safetyGradeList = [
    {
      value: 'A',
      name: 'A',
    },
    {
      value: 'B',
      name: 'B',
    },
    {
      value: 'C',
      name: 'C',
    },
    {
      value: 'D',
      name: 'D',
    },
    {
      value: 'E',
      name: 'E',
    },
  ];

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const { id } = useParams<{ id: string }>();
  const uploadApi = new UploadApi({ baseURL: Config.API_URL });
  const facilityApi = new FacilityApi({ baseURL: Config.API_URL });

  const setErrorModalText = useSetRecoilState(errorModalTextRecoil);
  const setCompleteModalState = useSetRecoilState(completeModalRecoil);
  const setInspectionLogAddModalState = useSetRecoilState(
    inspectionLogAddModalRecoil,
  );

  const [safetyGrade, setsafetyGrade] = useState<any>('A');
  const [inspector, setInspector] = useState<string>('');
  const [fileUrl, setFileUrl] = useState<string>('');
  const [fileName, setFileName] = useState<string>('');
  const [inspectionDate, setInspectionDate] = useState<string>(getTodayDate());

  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleFileUploadBtnClick = (type: string) => {
    if (type === 'file') {
      if (fileInputRef.current) {
        fileInputRef.current.click();
      }
    }
  };

  const handleFileChange = async (
    e: React.ChangeEvent<HTMLInputElement>,
    type: string,
  ) => {
    if (e.target.files) {
      const dto: FileUploadDto = {
        file: e.target.files[0],
      };
      try {
        const { data } = await uploadApi.fileuploadControllerUploadFile(dto);
        if (type === 'file') {
          setFileName(e.target.files[0].name);
          setFileUrl(String(data.file));
        }
      } catch (err: any) {}
    }
  };

  const handleFileDel = (type: string) => {
    if (type === 'file') {
      setFileName('');
      setFileUrl('');
    }
  };

  const handleSubmit = async () => {
    if (safetyGrade === '' || inspector === '') {
      setErrorModalText('빈 칸을 확인해 주세요.');
      return;
    }

    const dto: CreateInspectionLogDtoTx = {
      safetyGrade,
      inspector,
      fileUrl,
      fileName,
      inspectionDate,
    };

    try {
      await facilityApi.facilityControllerCreateInspectionLog(Number(id), dto, {
        headers: {
          Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
          'Content-Type': 'application/json',
        },
      });
      setCompleteModalState(true);
    } catch (err: any) {
      console.error(err);
    }
  };

  return (
    <>
      <ModalType1 width={1000}>
        <div className="title-box flex aic jcsb">
          <h1>점검일지 등록</h1>
          <button
            className="x-btn img-box"
            onClick={() => setInspectionLogAddModalState(false)}
          >
            <img src="/img/ico_x_444.svg" alt="" />
          </button>
        </div>
        <div className="cnt-area flex fdc">
          <div className="cnt-wrap flex fdc">
            <div className="cnt-box flex fdc">
              <div className="cnt-title-box flex jcsb aie">
                <div className="left-box">
                  <h2 className="tm">기본 정보</h2>
                </div>
                <div className="right-box flex">
                  <h3>
                    <span className="inblock">*</span>필수 항목
                  </h3>
                </div>
              </div>
              <CS.TableType2>
                <table>
                  <tbody>
                    <tr>
                      <th>
                        안전등급
                        <span className="star-point">*</span>
                      </th>
                      <td>
                        <IS.SelectType1 style={{ width: 190 }}>
                          <select
                            value={safetyGrade}
                            onChange={(e) => setsafetyGrade(e.target.value)}
                            className="selected"
                          >
                            {safetyGradeList.map((list, index) => (
                              <option key={index} value={list.value}>
                                {list.name}
                              </option>
                            ))}
                          </select>
                          <span className="img-box">
                            <img src="/img/arrow_bottom_555.svg" alt="" />
                          </span>
                        </IS.SelectType1>
                      </td>
                      <th>
                        점검자<span className="star-point">*</span>
                      </th>
                      <td>
                        <IS.TextInputType1
                          style={{ width: 190 }}
                          type="text"
                          value={inspector}
                          onChange={(e) => setInspector(e.target.value)}
                        />
                      </td>
                    </tr>
                    <tr>
                      <th>첨부파일</th>
                      <td colSpan={3}>
                        <div className="td-box">
                          <BS.Btn3Type5
                            type="button"
                            onClick={() => handleFileUploadBtnClick('file')}
                          >
                            파일 선택
                          </BS.Btn3Type5>
                          <input
                            type="file"
                            ref={fileInputRef}
                            onChange={(e) => handleFileChange(e, 'file')}
                            style={{ display: 'none' }}
                          />
                          <IS.FileTextType1>
                            {fileName === '' ? (
                              <span className="no-file-text">
                                선택된 파일 없음
                              </span>
                            ) : (
                              <span className="file-text">{fileName}</span>
                            )}
                            {fileName !== '' && (
                              <button
                                className="img-box"
                                type="button"
                                onClick={() => handleFileDel('file')}
                              >
                                <img src="/img/ico_x_FC5B5B.svg" alt="" />
                              </button>
                            )}
                          </IS.FileTextType1>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <th>점검 일자</th>
                      <td colSpan={3}>
                        <IS.TextInputType1
                          style={{ width: 190 }}
                          type="date"
                          value={inspectionDate}
                          onChange={(e) => setInspectionDate(e.target.value)}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CS.TableType2>
            </div>
          </div>
          <div className="btn-wrap">
            <BS.Btn2Type3
              type="button"
              onClick={() => setInspectionLogAddModalState(false)}
            >
              취소
            </BS.Btn2Type3>
            <BS.Btn2Type4 type="button" onClick={handleSubmit}>
              등록
            </BS.Btn2Type4>
          </div>
        </div>
      </ModalType1>
    </>
  );
};

export default InspectionLogAddModal;
